module.exports = __webpack_public_path__ + "media/images/flags/64/South-Ossetia-a34d6bc894baccc2124114ae12522cfa.png";